import React, { useEffect, useState } from "react"
import { connect } from 'react-redux';
import { useTranslation, Trans} from "react-i18next";

function Footer(props) {
	const [logoImagePath, setlogoImagePath] = useState([]);
	const [officialUrl, setOfficialUrl] = useState('');
	const [facebookUrl, setFacebookUrl] = useState('');
	const [twitterUrl, setTwitterUrl] = useState('');
	const [additionalUrl1, setAdditionalUrl1] = useState('');	
	const [additionalUrl2, setAdditionalUrl2] = useState('');
	const [additionalUrl3, setAdditionalUrl3] = useState('');
	const [additionalTitle1, setAdditionalTitle1] = useState('');
	const [additionalTitle2, setAdditionalTitle2] = useState('');
	const [additionalTitle3, setAdditionalTitle3] = useState('');
	const { t } = useTranslation();

	useEffect(() => {
		//ロゴのパスをセット
		//logoImagePath[0]:ja_header_file, logoImagePath[1]:en_header_file , logoImagePath[2]:main_header_file
		setlogoImagePath( (prevState) => ([ ...prevState, '/assets/img/common/logo-ja.png' ]) );
		setlogoImagePath( (prevState) => ([ ...prevState, '/assets/img/common/logo-en.png' ]) );
		setlogoImagePath( (prevState) => ([ ...prevState, '/assets/img/common/logo-main.png' ]) );

		if (props.customize) {
			setOfficialUrl(props.customize.official_url);
			setFacebookUrl(props.customize.facebook_url);
			setTwitterUrl(props.customize.twitter_url);
			setAdditionalInfo();
		}
	}, [props.customize]);

	useEffect(() => {
		setAdditionalInfo();
	}, [props.language]);

	const setAdditionalInfo = () => {
		//URLをセット
		if (props.customize) {
			setAdditionalUrl1(props.customize.additional_url1);
			setAdditionalUrl2(props.customize.additional_url2);
			setAdditionalUrl3(props.customize.additional_url3);
			if (props.language === 'ja_JP') {
				//日本語のタイトルをセット
				setAdditionalTitle1(props.customize.additional_title1);
				setAdditionalTitle2(props.customize.additional_title2);
				setAdditionalTitle3(props.customize.additional_title3);
			}
			else {
				//英語のタイトルをセット
				setAdditionalTitle1(props.customize.additional_title1_en);
				setAdditionalTitle2(props.customize.additional_title2_en);
				setAdditionalTitle3(props.customize.additional_title3_en);
			}
		}
	}

	/*
	if (props.donePageLoading !== true) {
		return <p></p>;
	}
	*/
	return (
		<>
		<style jsx="true">
		{`
			.footer-external {
				position: absolute;
				bottom: 60px;
				right: 40px;
				list-style: none;
				text-align:right;
			}
			.footer-external li {
				width: 110px;
				height: auto;
				float: right;
			}
			.footer-external li img {
				width: 100%;
				margin-bottom: 5px;
			}
			.footer-external li p {
				font-size: 0.6rem;
				line-height: 1.2em;
				text-align:left;
			}
			.footer-external li p a {
				color:white;
			}
			
			.footer-external-sp {
				bottom: 60px;
				right: 40px;
				list-style: none;
				margin-top: 40px;
			}
			.footer-external-sp li {
				width: auto;
				height: auto;
			}
			.footer-external-sp li img {
				width: 30%;
				margin-bottom: 5px;
			}
			.footer-external-sp li p {
				font-size: 0.6rem;
				line-height: 1.2em;
				text-align:left;
			}
			.footer-external-sp li p a {
				color:white;
			}

		`}
		</style>
		
		<footer className="global-footer">
			<div className="global-footer__inner">
				<div className="global-footer__logo">
				{ (props.language === 'ja_JP') ?
					<img src={logoImagePath[0]} />
            	: 
					<img src={logoImagePath[1]}/>
        		}	
				</div>
				<div className="footer-links-wrapper">
					<ul className="footer-links">
						<li className="footer-links__item"><a href="/guide">{t("menu.guide")}</a></li>
						<li className="footer-links__item"><a href="/confirm">{t("menu.confirm")}</a></li>
						<li className="footer-links__item"><a href="/faq">{t("menu.faq")}</a></li>
						<li className="footer-links__item"><a href="/privacy_policy">{t("menu.privacyPolicy")}</a></li>
						<li className="footer-links__item"><a href="/personal_information">{t("menu.personalInformation")}</a></li>
						<li className="footer-links__item"><a href="/specified_commercial_transaction_law">{t("menu.specifiedCommercialTransactionLaw")}</a></li>
						<li className="footer-links__item"><a href="/term_of_service">{t("menu.termOfService")}</a></li>
					</ul>
					<ul className="footer-social">
						{officialUrl && (
							<li className="footer-links__item"><a href={officialUrl} target="_blank" rel="noreferrer">{t("menu.footerOfficialSite")}</a></li>	
						)}
						{additionalUrl1 && additionalTitle1 && (
							<li className="footer-links__item"><a href={additionalUrl1} target="_blank" rel="noreferrer">{additionalTitle1}</a></li>
						)}
						{additionalUrl2 && additionalTitle2 && (
							<li className="footer-links__item"><a href={additionalUrl2} target="_blank" rel="noreferrer">{additionalTitle2}</a></li>
						)}
						{additionalUrl3 && additionalTitle3 && (
							<li className="footer-links__item"><a href={additionalUrl3} target="_blank" rel="noreferrer">{additionalTitle3}</a></li>
						)}
						{facebookUrl && (
							<li className="footer-social__item footer-social__item--facebook">
								<a href={facebookUrl} target="_blank" rel="noreferrer"><span>{t("menu.facebook")}</span></a>
							</li>
						)}
						{twitterUrl  && (
							<li className="footer-social__item footer-social__item--twitter">
								<a href={twitterUrl} target="_blank" rel="noreferrer"><span>{t("menu.twitter")}</span></a>
							</li>
						)}
						{/* */}
						<li className="footer-social__item footer-social__item--instagram">
							<a href={t("menu.instagramLink")} target="_blank" rel="noreferrer"><span>{t("menu.instagram")}</span></a>
						</li>
						<li className="footer-social__item footer-social__item--youtube">
							<a href={t("menu.youTubeLink")} target="_blank" rel="noreferrer"><span>{t("menu.youTube")}</span></a>
						</li>
						{/* SPのロゴここから */}
						<ul className="footer-external-sp sp-only" style={{ marginBottom: "30px" }}>
							{/*
							<li>
								<img src={t("footer.exIcon_0")}  />
								<p style={{marginBottom: "30px"}}><Trans i18nKey="footer.exText_0" components={{ l: <a className="unsubscribe-link" href={t("footer.exUrl_0")}>link</a> }}/></p>
							</li>
							*/}
							<li>
								<img src={t("footer.exIcon_1")}/>
								<p><Trans i18nKey="footer.exText_1"/></p>
							</li>
						</ul>
					</ul>
					{/*
					<ul className="footer-external pc-only" style={{ bottom: "200px" }}>
						<li style={{width: "440px"}}>
							<img src={t("footer.exIcon_0")} style={{width: "25%"}} />
							<p style={{marginBottom: "30px", textAlign:"right"}}><Trans i18nKey="footer.exText_0" components={{ l: <a className="unsubscribe-link" href={t("footer.exUrl_0")}>link</a> }}/></p>
						</li>
					</ul>
					*/}
					<ul className="footer-external  pc-only">
						<li>
							<img src={t("footer.exIcon_1")}/>
							<p><Trans i18nKey="footer.exText_1"/></p>
						</li>
					</ul>
					
				</div>
				<p className="powerdby">{t("app.name")}</p>
				<p className="copyright" />
			</div>
		</footer>
		</>
	);
}

const mapStateToProps = state => {
	return {
		language: state.piano.language,
		donePageLoading: state.offer.donePageLoading,
		customize: state.customize.customize,
	};
};

export default connect(mapStateToProps)(Footer);
